(function() {
    var itemTemplate =
        '   <div class="item-inner" data-id="{{id}}">' +
        '       <span class="img-area">' +
        '           <img onerror="lgkorUI.addImgErrorEvent(this);" src="{{smallImageAddr}}" alt="">' +
        '       </span>' +
        '       <div class="item-text">' +
        '           <p class="product-name"><span class="main-title"><span class="main">{{#raw modelDisplayNamePlusSpec}}</span></span></p>' +
        '           <p class="modal-name">{{modelName}}</p>' +
        '       </div>' +
        '   </div>' +
        '   <button type="button" class="btn-close"><span class="blind">닫기</span></button>'
    ;

    var itemTemplate2 =
        '<div class="item-inner">' +
        '   <div class="item-text">' +
        '       <button type="button" class="more-list"><span>제품 리스트 보기</span></button>' +
        '   </div>' +
        '</div>'
    ;

    var itemTemplate3 =
        '<div class="item-inner">' +
        '   <div class="item-text">' +
        '       <button tyle="button" class="desc">비교하고 싶은 제품을<br>추가로 선택해주세요.</button>' + /* 20220729 : p → button(변경) */
        '   </div>' +
        '</div>'
    ;

    var compare = {
        variables: {
            compareIds: '',
            categoryId: 'CT50000046', // 노트북
            previousCompareCount: 0
        },
        el: {
            $context: null,
            $productList: null
        },
        init: function(el) {
            var self = this;

            this.el.$context = $(el);
            this.setProperty();
            this.bindEvents();

            setTimeout(function() {
                self.setCompares();
                self.setCompareStatus();
            }, 500);

        },
        selector: {
            productList: '.result-list.product-list',
            btnCompare: 'button.btn-gr-compare'
        },
        setProperty: function() {
            this.el.$productList = $(this.selector.productList);
        },
        bindEvents: function() {
            var self = this;

            // 초기화
            $('button.btn.btn-reset').on('click', function(e){
                self.setClearCompare();
            });

            // 결과보기
            $('.compare-content button.btn.mix').on('click', function(e) {
                e.preventDefault();
                var domain = location.origin;
                if (location.hostname === 'localhost' || location.hostname.indexOf("branddev") > -1){
                    domain = "https://wwwdev50.lge.co.kr";
                } else if (location.hostname.indexOf('brandstg') > -1) {
                    domain = "https://wwwstg.lge.co.kr";
                } else {
                    domain = "https://www.lge.co.kr";
                }
                var queryString = '?modelId=';
                var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, self.variables.categoryId);

                queryString += vcui.array.map(storageCompare['data'], function(item) {
                    return item.id;
                }).join(',');
                queryString += '&gramIntoYn=Y';

                lgkorUI.removeCompareProd(self.variables.categoryId);

                location.href = domain + '/compare-products' + queryString;

            });

            // 비교하기 제거
            $('.gr-compare .list-inner li').on('click', '.btn-close', function(e) {
                e.preventDefault();
                var id = $(this).siblings('.item-inner').data("id");
                lgkorUI.removeCompareProd(self.variables.categoryId, id);
            });

            // 비교하기 내에 선택되지 않은 제폼 모듈 클릭 시
            $('.gr-compare .list-inner').on('click', 'li.item.default', function(e) {
                e.preventDefault();
                self.closeCompareBox();
                self.addToastAlert('contain');

                //$("#grc_result_list").focus();
            });

            // 비교하기 클릭
            self.el.$productList.on('click', self.selector.btnCompare, function(e) {
                e.preventDefault();
                var $item = $(this).closest('li').find('div.item');
                var $this = $item.find('button.btn-gr-compare');
                // 새로누르는 경우
                if(!$this.hasClass('on')) {
                    var compareObj = {
                        id: $item.data('model-id'),
                        smallImageAddr: $item.data('img-src'),
                        modelDisplayName: $item.data('model-display-name'),
                        modelDisplayNamePlusSpec: $item.data('model-display-name-plus-spec'),
                        modelName: $item.data('model-name')
                    };
                    //console.log($("#content").length)

                    lgkorUI.addCompareProd(self.variables.categoryId, compareObj);
                    // 비활성화 시키는 경우
                } else {
                    lgkorUI.removeCompareProd(self.variables.categoryId, $item.data('model-id'));
                }

                
                $(".gr-compare-box").attr("tabindex","0")
                $(".gr-compare-box").focus()
            });

            // 펼치기/닫기 버튼
            $('.right-cont .more-arr').on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass('close')) self.openCompareBox();
                else {
                    self.closeCompareBox();
                }
            });

            // 외부 클릭 시 닫기
            // $('.wrap').on('click', function(e) {



            //     if ($(e.target).text() === '비교하기' || $(e.target).closest('button.btn-gr-compare').length == 1 || $(e.target).hasClass('btn-close')) {
            //         e.preventDefault();
            //         return;
            //     }

            //     if ($(e.target).closest('.gr-compare-box').length < 1) {
            //         if ($('.right-cont .more-arr').hasClass('open') && $('.gr-compare-box').css('display') == 'block') {
            //             self.closeCompareBox();
            //         }
            //     }
            // });

            $(window).on("changeStorageData", function(e) {
                if (e.key == lgkorUI.COMPARE_KEY) {
                    self.setCompares();
                    self.setCompareStatus();
                }
            }).on("excessiveCompareStorage", function(){
                self.addToastAlert('excessive');
                self.updateCompareButton();
            });
        },

        addToastAlert: function(mode) {
            var msg;
            if(mode == "excessive") {
                msg = lgkorUI.getCompareLimit() + "개까지 비교가능합니다.";
            } else if (mode == "contain") {
                msg = "새로운 제품을 담아주세요.";
            } else {
                msg = "비교하기 기능이 초기화되었습니다.";
            }

            //BTOCSITE-77481 [웹앱 접근성 개선활동] 포커스 이동 수정
            if(mode == "contain" || mode == "reset") {
                $("#grc_result_list").attr("tabindex","0")
                $('.toast-message').vcToast('instance').show(msg,'#grc_result_list');
            } else {
                $('.toast-message').vcToast('instance').show(msg);
            }
        },

        setCompares: function() {
            var self = this;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, self.variables.categoryId);
            var isCompare = vcui.isEmpty(storageCompare);
            if(!isCompare) {
                var ids = vcui.array.map(storageCompare['data'], function(item){
                    return item.id;
                }).join('|');

                if (self.variables.compareIds != ids) {
                    self.variables.compareIds = ids;
                    // 초기화
                    for(var i=0; i<lgkorUI.getCompareLimit(); i++) {
                        $('.gr-compare .list-inner li').eq(i).html(vcui.template(itemTemplate3))
                            .removeClass('on')
                            .addClass('default');
                    }

                    storageCompare['data'].forEach(function(item, i) {
                        $('.gr-compare .list-inner li').eq(i).html(vcui.template(itemTemplate, item))
                            .removeClass('default')
                            .addClass('on');
                    });

                }
            }

            var leng = isCompare ? "0" : storageCompare.data.length;
            var $count = $('div.compare-title div.count');
            $count.text(leng + "/" + lgkorUI.getCompareLimit());
            this.compareBtnStatus();
            this.updateCompareButton();
        },

        setCompareStatus: function(){
            var self = this;
            var categoryId = self.variables.categoryId;
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
            var isCompare = vcui.isEmpty(storageCompare);
            var leng = isCompare ? 0 : storageCompare.data.length;

            if (!isCompare) {
                // if ($('.gr-compare-box').css('display') == 'none') {
                //     var height = $('.gr-compare-box').outerHeight(true);
                //     $('.gr-compare-box').css({display:'block', y:height});
                //
                //     // 첫 제품 담을 시 2초 뒤 닫기 처리
                //     if (leng == 1) {
                //         self.openCompareBox();
                //         setTimeout(function() {
                //             self.closeCompareBox();
                //         }, 2000);
                //     } else if(leng == lgkorUI.getCompareLimit()) {
                //         self.closeCompareBox();
                //     } else {
                //         self.openCompareBox();
                //     }
                //
                // } else {
                //     self.openCompareBox();
                // }
                if ($('.gr-compare-box').css('display') == 'none') {
                    var height = $('.gr-compare-box').outerHeight(true);
                    $('.gr-compare-box').css({display: 'block', y: height});
                }
                if (!$('.right-cont .more-arr').hasClass('open')) {
                    self.openCompareBox();
                }
                //BTOCSITE-77481 [웹앱 접근성 개선활동] 포커스 자동 이동 삭제
                // if (leng == 1 && self.variables.previousCompareCount == 0) {
                //     setTimeout(function() {
                //         self.closeCompareBox();
                //     }, 2000)
                // }
            } else {
                self.hideCompareBox();
            }

            self.variables.previousCompareCount = leng;
        },

        openCompareBox: function() {
            if (!$('div.floating-wrap').hasClass('gr-compare-on')) $('div.floating-wrap').addClass('gr-compare-on');
            if (!$('div.btn-floating-wrap').hasClass('gr-compare-on')) $('div.btn-floating-wrap').addClass('gr-compare-on');
            $('.right-cont .more-arr').removeClass('close').addClass('open');
            $('.right-cont .more-arr').attr('aria-expanded', true);
            $('.right-cont .more-arr span.blind').text('제품 비교하기 닫기');
            $('.gr-compare-box').stop().transition({y: 0}, 200, "easeInOutCubic");
        },

        closeCompareBox: function() {
            $('.right-cont .more-arr').removeClass('open').addClass('close');
            $('.right-cont .more-arr').attr('aria-expanded', false);
            $('.right-cont .more-arr span.blind').text('제품 비교하기 펼치기');

            var height = $('.gr-compare-box').outerHeight(true) - $('.gr-compare .compare-title').outerHeight(true);
            $('.gr-compare-box').stop().transition({y: height}, 200, "easeInOutCubic");
            $("#grc_result_list").focus(); //BTOCSITE-77481 [웹앱 접근성 개선활동] 팝업 닫은 후 리스트 이동
        },

        hideCompareBox: function() {
            if ($('div.floating-wrap').hasClass('gr-compare-on')) $('div.floating-wrap').removeClass('gr-compare-on');
            if ($('div.btn-floating-wrap').hasClass('gr-compare-on')) $('div.btn-floating-wrap').removeClass('gr-compare-on');
            if ($('.right-cont .more-arr').hasClass('open')) {
                this.closeCompareBox();
            }
            $('.gr-compare-box').css('display', 'none');
        },
        updateCompareButton: function() {
            var count = $('.gr-compare-box .list-inner li').filter('.on').length;
            if (count > 1) {
                $('.compare-content button.btn.mix').prop('disabled',false);
            } else {
                $('.compare-content button.btn.mix').prop('disabled',true);
            }
        },

        setClearCompare: function() {
            this.closeCompareBox();
            lgkorUI.removeCompareProd(this.variables.categoryId);
            this.addToastAlert('reset');
        },

        compareBtnStatus: function() {
            var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, this.variables.categoryId);
            this.el.$productList.find('button.btn-gr-compare').removeClass('on')
                .find('.blind').text('');

            if (!vcui.isEmpty(storageCompare)) {
                for (var property in storageCompare) {
                    storageCompare['data'].forEach(function (el) {
                        $("[data-model-id=" + el.id + "] button.btn-gr-compare").addClass("on")
                            .find('.blind').text('선택됨');
                    });
                }
            }
        },
    };

    $(window).ready(function() {
        compare.init('.gram-cont');
    });
})();